export const MIN_SELECTED_YEARS = 1;
export const MAX_SELECTED_YEARS = 3;
export const YEAR_FILTER_SKELETON_COUNT = 5;

// How many year cards fill the track at each breakpoint.
export const YEAR_FILTER_VISIBLE_CARDS = 3;
export const YEAR_FILTER_VISIBLE_CARDS_TABLET = 2;
export const YEAR_FILTER_VISIBLE_CARDS_MOBILE = 1;
